import { render } from "./Loadingservices.vue?vue&type=template&id=7781f463&scoped=true"
import script from "./Loadingservices.vue?vue&type=script&lang=js"
export * from "./Loadingservices.vue?vue&type=script&lang=js"

import "./Loadingservices.vue?vue&type=style&index=0&id=7781f463&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7781f463"]])

export default __exports__